import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Icon, RelatedArticlesDisplay } from "../_components";
import { useMaps, useTime, useApp } from "../_contexts";
import { ChronosDate, parseBBCode } from "../_helpers";
import {
  SidebarCover,
  SidebarOptions,
  SidebarDateDisplay,
} from "./_components";

export function SidebarEventDetails(props) {
  const { item } = props;
  const [marker, setMarker] = useState(undefined);
  const [cover, setCover] = useState(undefined);
  const { items: images } = useSelector((state) => state.images);
  const { items: maps } = useSelector((state) => state.maps);

  const { goTo, goToMap, currentMap } = useMaps();
  const {
    calendar: globalCalendar,
    granularity,
    unitsDisplay,
    currentDate,
    setCurrentDate,
    updateScrollPosition,
  } = useTime();
  const { openSidebar } = useApp();
  const { items: markers } = useSelector((state) => state.markers);
  // console.log("Sidebar Item: ", item);
  // const cover = item.cover
  //   ? item.cover.url
  //   : 'https://www.worldanvil.com/images/logo-550px.png';

  // useEffect(() => {

  // }, [item]);

  useEffect(() => {
    // if (item.marker && item.marker !== null) {
    //   setMarker(item.marker);
    // }
    if (item.cover) {
      if (typeof item.cover === "string" && item.cover.length > 0) {
        const image = images.find((i) => i._id === item.cover);
        if (image) {
          setCover(image.url);
        } else {
          // setCover(item.cover);
        }
      } else if (item.cover._id) {
        setCover(item.cover.url);
      }
    }
    if (item.marker) {
      if (typeof item.marker !== "string" && item.marker._id) {
        setMarker(item.marker);
      } else if (typeof item.marker === "string" && item.marker.length > 0) {
        const relatedMarker = markers.find((m) => m._id === item.marker);
        if (relatedMarker) {
          setMarker(relatedMarker);
        }
      }
    }

    //.......................
    const targetDate = new ChronosDate(item.fromDate, {
      calendar: globalCalendar,
    });
    const current = new ChronosDate(currentDate, { calendar: globalCalendar });
    const segment = targetDate.getTimelineSegment(granularity, {
      unitCountDisplay: unitsDisplay,
    });
    const pos = targetDate.getPositionFromStart(segment.start, granularity);
    if (!current.isBetween(segment.start, segment.end)) {
      setCurrentDate(segment.start);
    }
    updateScrollPosition(pos);
  }, [item]);

  useEffect(() => {
    if (marker && marker._id) {
      const { parentMap, coords } = marker;
      let map = maps.find((m) => m._id === parentMap);
      const newCoords = {
        ...coords,
        z: map && map.options ? map.options.zoomMax : coords.z,
      };
      if (currentMap && currentMap._id === parentMap) {
        goTo(newCoords);
      } else {
        goToMap(parentMap, newCoords);
      }
      // console.log('Current Map:', currentMap);
      // console.log('New Map: ', parentMap);
    }
  }, [marker]);

  const handleLocationClick = (ev) => {
    if (marker && marker._id) {
      const currentMapID = (currentMap && currentMap._id) || currentMap;
      if (currentMapID === marker.parentMap) {
        console.log("navigating to current map coords", marker.coords);
        goTo(marker.coords);
      } else {
        console.log(
          "Navigating to new map coords",
          marker.parentMap,
          marker.coords
        );
        goToMap(marker.parentMap, marker.coords);
      }
      openSidebar({
        type: "locationMarker",
        payload: { marker },
      });
    }
  };

  // const handleMarkerClick = (ev) => {
  //   if (marker) {
  //     console.log('Clicky!');
  //     goTo(marker.coords);
  //   }
  // };

  const cleanedDescription = parseBBCode(item.description);
  console.log("-----Marker", marker, currentMap);
  return (
    <div className="chronos-sidebar-content chronos-sidebar-event-details-wrapper">
      <SidebarCover url={cover} name={item.title} />
      <div className="chronos-sidebar-body">
        <div className="chronos-sidebar-type">
          <span>Event</span>
        </div>
        <h4 className="chronos-sidebar-title">{item.title}</h4>
        <SidebarDateDisplay
          from={item.fromDate}
          to={item.toDate}
          calendar={
            typeof eventCalendar !== "undefined"
              ? eventCalendar
              : globalCalendar
          }
        />
        {/* Location */}
        {marker && marker.title && (
          <span
            className="chronos-sidebar-location-name"
            onClick={handleLocationClick}
          >
            {marker.title}
          </span>
        )}
        <hr className="chronos-sidebar-separator" />

        {/* {marker && (
          <span
            className="chronos-sidebar-marker-btn"
            onClick={handleMarkerClick}
          >
            <Icon icon="far fa-search-location" />
          </span>
        )} */}
        <div
          className="chronos-sidebar-description"
          dangerouslySetInnerHTML={{ __html: cleanedDescription }}
        ></div>
        {item && item.linkedArticles && item.linkedArticles.length > 0 && (
          <React.Fragment>
            <RelatedArticlesDisplay articles={item.linkedArticles} />
          </React.Fragment>
        )}

        <SidebarOptions item={item} type="event" />
      </div>
    </div>
  );
}
